export function getCurrencyMultiplierLabel(multiplier: number) {
	if (multiplier < 2) {
		return `+${+(multiplier - 1).toFixed(2) * 100}%`;
	} else {
		return `${multiplier}x`;
	}
}
